import axios from 'axios'

export const LOADING = 'Loading'

export const SELECTCOLEGIO = 'selectColegio'
export const SELECTANIO = 'selectAnio'

export function loading(value) {
  
    return (dispatch, getState) => {
        dispatch( { type: LOADING , payload: value}) 
    }
    
} 

export function setUsuarioLogin(value) {
  
    return (dispatch, getState) => {
        dispatch( { type: 'setUsuario' , payload: value}) 
    }
    
} 

export function selectColegioStatus(value) {
  
    return (dispatch, getState) => {
        dispatch( { type: SELECTCOLEGIO , payload: value}) 
    }
    
} 

export function selectAnioStatus(value) {
  
    return (dispatch, getState) => {
        dispatch( { type: SELECTANIO , payload: value}) 
    }
    
}